enum RouteName {
    LOGIN = 'Login',
    HOME = 'Home',
    USER_OVERVIEW = 'UserOverview',
    CREATE_SHIPMENT = 'CreateShipment',
    SHIPMENT_ORDER = 'ShipmentOrder',
    SHIPMENT_OVERVIEW = 'ShipmentOverview',
    PARCEL_TRACKING = 'ParcelTracking',
    TRANSPORTATION_OVERVIEW = 'TransportationOverview',
    TRANSPORTATION_LIST_CREATE = 'TransportationListCreate',
    ASSIGN_PARCELS_TO_LOADING_LIST = 'AssignParcelsToLoadingList',
    PARCEL_AUTO_ASSIGNMENT = 'ParcelAutoAssignment',
    PARCEL_STATUS_ASSIGNMENT = 'ParcelStatusAssignment',
    REVERT = 'Revert',
    REPRINT = 'Reprint',
    FORWARD = 'Forward',
    INITIAL = 'Initial',
    PARCEL_DATA = 'ParcelData',
    // TODO to be removed
    MT_WEIGHING_SCALE_TESTING = 'MtWeighingScaleTesting'
}

export default RouteName;
